import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldCheck2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShieldCheck2"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V18.618L12 23.118L3 18.618V3ZM15.9142 10.25L14.5 8.83579L11 12.3358L9.5 10.8358L8.08579 12.25L11 15.1642L15.9142 10.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShieldCheck2;
